/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Push_Native_EnableInputs */

const th_push_native_enable = /** @type {(inputs: Push_Native_EnableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เปิดการแจ้งเตือน`)
};

const en_push_native_enable = /** @type {(inputs: Push_Native_EnableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turn on notifications`)
};

const ja_push_native_enable = /** @type {(inputs: Push_Native_EnableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通知をオンにする`)
};

const zh_push_native_enable = /** @type {(inputs: Push_Native_EnableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开通知`)
};

const es_push_native_enable = /** @type {(inputs: Push_Native_EnableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activar notificaciones`)
};

const pt_push_native_enable = /** @type {(inputs: Push_Native_EnableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ligar notificações`)
};

const id_push_native_enable = /** @type {(inputs: Push_Native_EnableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nyalakan notifikasi`)
};

const fr_push_native_enable = /** @type {(inputs: Push_Native_EnableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activer les notifications`)
};

const tl_push_native_enable = /** @type {(inputs: Push_Native_EnableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buksan ang mga notipikasyon`)
};

const vi_push_native_enable = /** @type {(inputs: Push_Native_EnableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bật thông báo`)
};

const ko_push_native_enable = /** @type {(inputs: Push_Native_EnableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`알림 켜기`)
};

const de_push_native_enable = /** @type {(inputs: Push_Native_EnableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benachrichtigungen einschalten`)
};

const ru_push_native_enable = /** @type {(inputs: Push_Native_EnableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Включить уведомления`)
};

const tr_push_native_enable = /** @type {(inputs: Push_Native_EnableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bildirimleri aç`)
};

const it_push_native_enable = /** @type {(inputs: Push_Native_EnableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attiva le notifiche`)
};

const pl_push_native_enable = /** @type {(inputs: Push_Native_EnableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Włącz powiadomienia`)
};

const uk_push_native_enable = /** @type {(inputs: Push_Native_EnableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Увімкнути сповіщення`)
};

const hi_push_native_enable = /** @type {(inputs: Push_Native_EnableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सूचनाएँ चालू करें`)
};

const ar_push_native_enable = /** @type {(inputs: Push_Native_EnableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تفعيل الإشعارات`)
};

const ms_push_native_enable = /** @type {(inputs: Push_Native_EnableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hidupkan pemberitahuan`)
};

const bn_push_native_enable = /** @type {(inputs: Push_Native_EnableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`বিজ্ঞপ্তি চালু করুন`)
};

const zh_tw2_push_native_enable = /** @type {(inputs: Push_Native_EnableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開啟通知`)
};

const zh_hk2_push_native_enable = /** @type {(inputs: Push_Native_EnableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開啟通知`)
};

const ur_push_native_enable = /** @type {(inputs: Push_Native_EnableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اطلاعات چالو کریں`)
};

const fa_push_native_enable = /** @type {(inputs: Push_Native_EnableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`روشن کردن اعلان‌ها`)
};

const sw_push_native_enable = /** @type {(inputs: Push_Native_EnableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Washa arifa`)
};

const nl_push_native_enable = /** @type {(inputs: Push_Native_EnableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meldingen aanzetten`)
};

/**
* | output |
* | --- |
* | "Turn on notifications" |
*
* @param {Push_Native_EnableInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const push_native_enable = /** @type {((inputs?: Push_Native_EnableInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Native_EnableInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_push_native_enable(inputs)
	if (locale === "ja") return ja_push_native_enable(inputs)
	if (locale === "zh") return zh_push_native_enable(inputs)
	if (locale === "es") return es_push_native_enable(inputs)
	if (locale === "pt") return pt_push_native_enable(inputs)
	if (locale === "id") return id_push_native_enable(inputs)
	if (locale === "fr") return fr_push_native_enable(inputs)
	if (locale === "tl") return tl_push_native_enable(inputs)
	if (locale === "vi") return vi_push_native_enable(inputs)
	if (locale === "ko") return ko_push_native_enable(inputs)
	if (locale === "de") return de_push_native_enable(inputs)
	if (locale === "ru") return ru_push_native_enable(inputs)
	if (locale === "tr") return tr_push_native_enable(inputs)
	if (locale === "it") return it_push_native_enable(inputs)
	if (locale === "pl") return pl_push_native_enable(inputs)
	if (locale === "uk") return uk_push_native_enable(inputs)
	if (locale === "hi") return hi_push_native_enable(inputs)
	if (locale === "ar") return ar_push_native_enable(inputs)
	if (locale === "ms") return ms_push_native_enable(inputs)
	if (locale === "bn") return bn_push_native_enable(inputs)
	if (locale === "zh-TW") return zh_tw2_push_native_enable(inputs)
	if (locale === "zh-HK") return zh_hk2_push_native_enable(inputs)
	if (locale === "ur") return ur_push_native_enable(inputs)
	if (locale === "fa") return fa_push_native_enable(inputs)
	if (locale === "sw") return sw_push_native_enable(inputs)
	if (locale === "nl") return nl_push_native_enable(inputs)
	return en_push_native_enable(inputs)
});